var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import ArticleRelatedCard from '../Cards/ContentCard';
import './index.scss';
import SwiperCore, { Virtual, Navigation } from 'swiper';
// import CarouselArrow from './CarouselArrow';
SwiperCore.use([Virtual, Navigation]);
import '../../lib/styles/swiper.scss';
import { useWindowSize } from '../../hooks/useWindowSize';
import card0 from '../../assets/images/twoCards/MaskGroup.png';
import card1 from '../../assets/images/twoCards/MaskGroup-2.png';
var defaultProps = {
    data: {
        title: 'Related Content',
        contentCardList: [
            {
                title: 'What Are Value Stocks? All You Need To Know',
                date: '11 OCT 2021',
                image: card0,
            },
            {
                title: 'Why Individual Stock Selection Is A Bad Approach To Investing',
                date: '11 OCT 2021',
                image: card1,
            },
            {
                title: 'Momentum Stocks: Does Popularity Result In Profitability?',
                date: '11 OCT 2021',
                image: card1,
            },
        ],
    },
};
export var TwoCards = function (props) {
    var _a = useState(0), scrolledBy = _a[0], setScrolledBy = _a[1];
    var navigationPrevRef = useRef(null);
    var navigationNextRef = useRef(null);
    var width = useWindowSize()[0];
    var isMobile = width < 768;
    var isTablet = window.innerWidth < 1440;
    var isDesktop = window.innerWidth >= 1440;
    var scrollHandler = function (e) {
        var target = e.target;
        var scrollLeft = target.scrollLeft, scrollWidth = target.scrollWidth, clientWidth = target.clientWidth;
        var width = scrollWidth - clientWidth;
        setScrolledBy((scrollLeft / width) * 100);
    };
    // useEffect(() => {
    //   const tl = gsap.timeline({
    //     scrollTrigger: {
    //       trigger: '.twoCardsContainer',
    //       start: 'top center',
    //     },
    //   });
    //   tl.to(
    //     ['.twocards_title', '.twocards_cards'],
    //     {
    //       autoAlpha: 1,
    //       duration: 1,
    //       stagger: 0.5,
    //     },
    //   );
    // }, []);
    return (_jsx("div", __assign({ className: "text-white w-100vw flex flex-col md:items-center snap-start twoCardsContainer " + (props.className || '') }, { children: _jsxs("div", __assign({ className: "flex w-full flex-col " + 'two-cards' + " " }, { children: [_jsxs("div", __assign({ className: "leading-padding" }, { children: [_jsx("p", __assign({ className: "mb-4 text-[18px] leading-[1.33] text-[#343741] md:mb-4 md:text-[22px] md:leading-[1.45] lg:text-[32px] lg:leading-[1.25] twocards_title", style: {
                                // visibility: 'hidden',
                                padding: "" + (window.innerWidth < 768 ? '0px 24px 0px 24px' : ''),
                                fontSize: "" + (window.innerWidth < 768 && '22px'),
                            } }, { children: props.title }), void 0),
                        _jsx("hr", { className: "header-divider mx-[24px] md:block new-spacer", style: {
                                borderTop: 'solid 1px #d8dcdb',
                                margin: "" + (window.innerWidth >= 768 ? '0px 0px 32px 0px' : ''),
                                width: "" + (window.innerWidth >= 768 ? '100%' : ''),
                            } }, void 0)] }), void 0),
                _jsx("div", __assign({ className: "flex snap-x snap-mandatory  px-[24px] pb-[48px] md:w-full overflow-x-auto\n          md:px-0 twocards_cards", onScroll: scrollHandler }, { children: props.contentCardList.map(function (contentCard, i) { return (_jsx(ArticleRelatedCard, { title: contentCard.title, date: contentCard.date, image: contentCard.image, articleLink: contentCard.cta.url }, i)); }) }), void 0),
                (isMobile || (isTablet && props.contentCardList.length > 2)) && (_jsx("div", __assign({ className: "mx-[24px] h-[1px] leading-padding " + (props.contentCardList.length ? 'hideInXl' : 'md:hidden'), style: {
                        backgroundColor: '#005f9e80',
                        // width: 'calc(100% - 48px)'
                        width: "" + (window.innerWidth >= 768 ? 'calc(100%)' : 'calc(100% - 48px)'),
                        margin: "" + (window.innerWidth >= 768 ? '0px 0px' : '0px 24px'),
                    } }, { children: _jsx("div", { className: "ml-[px] h-full w-[100px] bg-[#2d7fb6]", style: {
                            marginLeft: "calc(" + scrolledBy + "% - " + scrolledBy + "px)",
                        } }, void 0) }), void 0))] }), void 0) }), void 0));
};
TwoCards.defaultProps = defaultProps;
